export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9539.3d585580.jpg";